import { Link } from "office-ui-fabric-react"

const MyCalendarExceptionsListTooltip = () => {
    return <div>Specify calendar exceptions for this resource (vacation, sickness leave, etc.). If calendar exceptions are set for the same date as global calendar exceptions, they will take precedence over the tenant-wide settings for this resource.
        <br />
        Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/621569-calendar" target="_blank">article</Link> for more details.</div>
}

export default MyCalendarExceptionsListTooltip;